/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyOptionChoice from './survey-option-choice';
import SurveyOptionChoiceDetail from './survey-option-choice-detail';
import SurveyOptionChoiceUpdate from './survey-option-choice-update';
import SurveyOptionChoiceDeleteDialog from './survey-option-choice-delete-dialog';

const SurveyOptionChoiceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyOptionChoice />} />
    <Route path="new" element={<SurveyOptionChoiceUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyOptionChoiceDetail />} />
      <Route path="edit" element={<SurveyOptionChoiceUpdate />} />
      <Route path="delete" element={<SurveyOptionChoiceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyOptionChoiceRoutes;
